<div id="acknowledgment" class="registration container">
  <form novalidate autocomplete="off" (ngSubmit)="forward()">

    <section class="card">
      <div class="card-header">
        <div class="card-title">
          <h1>Welcome to the {{'programName' | copy | async}} Enrollment Website!</h1>
        </div>
      </div>
      <article class="p-4">
        <div
          [innerHTML]="'copy.html.new_instructions' | copy | async"
          class="login-info"
        ></div>
        <span>
          <img
            class="instructions"
            alt="Screenshots of the current sign-on process for Ford sites compared with the new process. The new process reduces the number of screens and the number of input fields."
            src="assets/images/new_login.png"
          />
        </span>
        <!--    
        <span></span>
        <strong class="w-100"> Login help:</strong> <a
          href="mailto:{{'travelHQEmail' | copy | async}}">{{'travelHQEmail' | copy | async}}</a> -->
      </article>
    </section>
    <section>
      <div class="button_group d-flex">
        <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
          Continue to Login Page
        </button>
        <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
          <i class="fas fa-spinner fa-spin"></i>
        </button>
      </div>
      
    </section>
  </form>
</div>
